import { apiJson } from "@/shared/lib/api-client.ts";
import type { CohortLens, PeerCohortResponse } from "../types/peer-cohort.ts";

interface ApiResponse<T> {
  data: T;
}

export async function getPeerCohort(
  projectId: string,
  lens: CohortLens
): Promise<PeerCohortResponse> {
  const payload = await apiJson<ApiResponse<PeerCohortResponse>>(
    `/v1/admin/intelligence/peer-cohort/${encodeURIComponent(projectId)}?lens=${encodeURIComponent(lens)}`
  );
  return payload.data;
}
